// extracted by mini-css-extract-plugin
module.exports = {"err":"style_err__1GKMd"};